export default __webpack_public_path__ + "1fe3170adedae0f1c7caf4d80e77a297.jpg";